import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { InsuranceService } from '../../../../../services/insurance.service';

import { MessageService } from 'primeng/api';
import { SelectItem } from 'primeng/api';
import { HelpersService } from '../../../../../services/helpers.service';

declare var google: any;

interface ConfiguredTask {
  ID: number;
  Name: string;
}

@Component({
  selector: 'app-view-claims',
  templateUrl: './view-claims.component.html',
  styleUrls: ['./view-claims.component.scss', '../../css/_shared.scss'],
  providers: [MessageService],
  encapsulation: ViewEncapsulation.None,
})
export class ViewClaimsComponent implements OnInit {
  public claimID = 0;
  currentStatusID = 0;
  ////uploadedFiles: any[] = [];
  //public employees: SelectItem[] = [];
  //public selectedEmployee: any;
  //public selectedTaskEmployee: any;

  selectedNavigationItem: any;

  public navigationItems: any = [];
  public statuses: SelectItem[] = [];
  public selectedStatus: any;
  public columns: any = [];
  public claims: any = [];
  public showClaim: boolean = false;

  public status: string = 'All Claims';
  //public showClaim: boolean = false;
  //public tabMenuItems: any[] = [];
  //public selectedTabMenuItem: any;

  //public activeItem: MenuItem;
  //claimObject: Claim;

  //bikes: string[] = [];
  //components: string[] = [];
  //bikeSelectList: SelectItem[] = [];
  //bikeSelected: Bike;

  //configuredTasks: SelectItem[];
  //selectedConfiguredTasks: ConfiguredTask;

  //public showTasks: boolean = true;
  //public showClaims: boolean = false;
  //public showAttachments: boolean = false;
  //public showQuotes: boolean = false;
  //public showMessages: boolean = false;
  //public showProcurement: boolean = false;

  //public dueDate: Date;
  //public note: string = "";
  //public allNotes: any[] = [];

  //excess: number = 0;
  //sumInsured: number = 0;

  //incidentTypes: SelectItem[];
  //selectedIncidentType: any;

  //partners: SelectItem[];

  //mapOptions: any;
  //overlays: any[];

  constructor(
    public insuranceService: InsuranceService,
    public helpersService: HelpersService,
  ) {}

  getOverdueOrNot(val) {
    if (val === 'No tasks') return false;

    var x = new Date(val);
    x.setHours(0, 0, 0, 0);
    var y = new Date();
    y.setHours(0, 0, 0, 0);
    return x < y;
    //return (x.getFullYear() < new Date().getFullYear() || x.getMonth() < new Date().getMonth()) && x.getDate() < new Date().getDate()
  }

  RefreshClaims() {
    //this.claims = [];
    this.insuranceService
      .getClaims(this.currentStatusID)
      .subscribe((response) => {
        var obj = JSON.parse(response);
        this.claims = [];
        for (var i = 0; i < obj.Claims.length; i++) {
          this.claims.push(obj.Claims[i]);
        }
      });
  }

  ngOnChanges(changes) {
    this.RefreshClaims();
  }

  ngOnInit() {
    setInterval(() => {
      this.RefreshClaims();
    }, 10000);

    this.navigationItems.push({
      ID: 0,
      title: 'All Claims',
      backgroundImage: '',
    });
    this.insuranceService.getClaimsStatus().subscribe((response) => {
      var obj = JSON.parse(response);
      for (var i = 0; i < obj.ClaimStatus.length; i++) {
        this.navigationItems.push({
          ID: obj.ClaimStatus[i].ID,
          title: obj.ClaimStatus[i].Description,
          backgroundImage: obj.ClaimStatus[i].Icon,
        });
        this.statuses.push({
          label: obj.ClaimStatus[i].Description,
          value: {
            ID: obj.ClaimStatus[i].ID,
            title: obj.ClaimStatus[i].Description,
            backgroundImage: obj.ClaimStatus[i].Icon,
          },
        });
      }

      this.selectedNavigationItem = this.navigationItems[0];
      this.currentStatusID = this.selectedNavigationItem.ID;
    });

    this.insuranceService.getClaims(0).subscribe((response) => {
      var obj = JSON.parse(response);
      for (var i = 0; i < obj.Claims.length; i++) {
        this.claims.push(obj.Claims[i]);
      }
    });

    this.columns = [
      { header: 'Claim', field: 'ClaimNumber', type: 'string' },
      { header: 'Insurer', field: 'Insurer', type: 'string' },
      { header: 'Customer', field: 'InsuredName', type: 'string' },
      { header: 'Age (in days)', field: 'Age', type: 'string' },
      { header: 'Status', field: 'Status', type: 'string' },
      { header: 'Due date', field: 'DueDate', type: 'days' },
      { header: 'Assessor', field: 'AssigneeName', type: 'string' },
      { header: '', field: 'ID', type: 'action' },
    ];

    //this.claimObject = new Claim(0, 0, "", "", 0, "", 0, "", 0, 0, "", 0, 0, new Date(), "", "", "", "", "", "", "", "", [], [], "", "");

    //this.insuranceService.getClaimsStatus().subscribe(response => {
    //  var obj = JSON.parse(response);
    //  for (var i = 0; i < obj.ClaimStatus.length; i++) {
    //    this.navigationItems.push({ ID: obj.ClaimStatus[i].ID, title: obj.ClaimStatus[i].Description, backgroundImage: obj.ClaimStatus[i].Icon });
    //    this.statuses.push({ label: obj.ClaimStatus[i].Description, value: { ID: obj.ClaimStatus[i].ID, title: obj.ClaimStatus[i].Description, backgroundImage: obj.ClaimStatus[i].Icon } });
    //  }

    //  this.navigationItems.push({ ID: 0, title: "All Claims", backgroundImage: "" });
    //  this.selectedNavigationItem = this.navigationItems[0];
    //  this.currentStatusID = this.selectedNavigationItem.ID;
    //});

    //this.insuranceService.getClaims(1).subscribe(response => {
    //  var obj = JSON.parse(response);
    //  for (var i = 0; i < obj.Claims.length; i++) {
    //    this.claims.push(obj.Claims[i]);
    //  }
    //});

    //this.insuranceService.getPossibleAssignees().subscribe(response => {
    //  var obj = JSON.parse(response);
    //  for (var i = 0; i < obj.Employees.length; i++) {
    //    this.employees.push({ label: obj.Employees[i].Name, value: obj.Employees[i] });
    //  }
    //});

    //this.configuredTasks = [
    //  { label: 'Select pre-typed task or type your own', value: null }
    //];

    //this.insuranceService.getConfiguredNotes().subscribe(response => {

    //  var obj = JSON.parse(response);
    //  for (var i = 0; i < obj.ClaimTasks.length; i++) {
    //    this.configuredTasks.push({ label: obj.ClaimTasks[i].Description, value: { ID: obj.ClaimTasks[i].ID } });
    //  }
    //});

    //this.incidentTypes = [
    //  { label: 'Select Incident Type', value: null },
    //  { label: 'Accidental damage', value: { label: "Accidental damage" } },
    //  { label: 'Theft from home', value: { label: "Theft from home" } },
    //  { label: 'Theft away from home', value: { label: "Theft away from home" } },
    //];

    //this.tabMenuItems = [
    //  { ID: 1, title: "Tasks/Notes", backgroundImage: "https://cdn3.iconfinder.com/data/icons/contact-us-set-1/256/64-512.png" },
    //  { ID: 2, title: "Claim form", backgroundImage: "https://cdn3.iconfinder.com/data/icons/contact-us-set-1/256/64-512.png" },
    //  { ID: 3, title: "Attachments", backgroundImage: "https://cdn3.iconfinder.com/data/icons/contact-us-set-1/256/62-512.png" },
    //  { ID: 4, title: "Quotes", backgroundImage: "https://cdn3.iconfinder.com/data/icons/contact-us-set-1/256/20-512.png" },
    //  { ID: 6, title: "Search", backgroundImage: "https://cdn3.iconfinder.com/data/icons/contact-us-set-1/256/38-512.png" },
    //  { ID: 5, title: "Messaging", backgroundImage: "https://cdn3.iconfinder.com/data/icons/contact-us-set-1/256/38-512.png" },
    //];
  }

  onRowSelect(event) {
    this.displayClaim(event.data.ID);
  }

  public getClaims(statusID) {
    this.status = '';
    for (var i = 0; i < this.navigationItems.length; i++) {
      if (this.navigationItems[i].ID == statusID)
        this.status = this.navigationItems[i].title;
    }

    (this.currentStatusID = statusID), (this.claims = []);
    //this.images = [];
    //this.documents = [];

    this.insuranceService.getClaims(statusID).subscribe((response) => {
      if (response !== '') {
        var obj = JSON.parse(response);
        for (var i = 0; i < obj.Claims.length; i++) {
          this.claims.push(obj.Claims[i]);
        }
      }
    });
  }

  public displayClaim(claimID) {
    this.claimID = claimID;
    this.showClaim = true;

    //  this.selectedTabMenuItem = this.tabMenuItems[0];

    //  this.claimObject = new Claim(0, 0, "", "", 0, "", 0, "", 0, 0, "", 0, 0, new Date(), "", "", "", "", "", "", "", "", [], [], "", "");
    //  this.bikes = [];
    //  this.bikeSelectList = [];
    //  this.allNotes = [];
    //  this.components = [];

    //  //this.images = [];

    //  this.showClaim = true;
    //  try {
    //    this.insuranceService.getClaim(claimID).subscribe(response => {
    //      this.setClaimObj(response);
    //    });
    //  } catch (e) {
    //  }
  }

  //minimizeAndSaveClaim() {
  //  this.showClaim = false;
  //  if (this.claimObject.Notes == undefined)
  //    this.claimObject.Notes = [];

  //  if (this.claimObject.Notes == undefined)
  //    this.claimObject.Notes = [];

  //  for (var i = 0; i < this.allNotes.length; i++) {
  //    this.claimObject.Notes.push(
  //      {
  //        ID: this.allNotes[i].ID,
  //        ClaimID: this.allNotes[i].ClaimID,
  //        DueDate: this.allNotes[i].DueDate,
  //        Description: this.allNotes[i].Description,
  //        Completed: this.allNotes[i].Completed,
  //        Assignee: this.allNotes[i].Assignee,
  //        AssigneeID: this.allNotes[i].AssigneeID,
  //      }
  //    );
  //  }

  //  this.saveClaim();
  //}

  //dontMinimizeAndSaveClaim() {
  //  if (this.claimObject.Notes == undefined)
  //    this.claimObject.Notes = [];

  //  if (this.claimObject.Notes == undefined)
  //    this.claimObject.Notes = [];

  //  for (var i = 0; i < this.allNotes.length; i++) {
  //    this.claimObject.Notes.push(
  //      {
  //        ID: this.allNotes[i].ID,
  //        ClaimID: this.allNotes[i].ClaimID,
  //        DueDate: this.allNotes[i].DueDate,
  //        Description: this.allNotes[i].Description,
  //        Completed: this.allNotes[i].Completed,
  //        Assignee: this.allNotes[i].Assignee,
  //        AssigneeID: this.allNotes[i].AssigneeID,
  //      }
  //    );
  //  }

  //  this.saveClaim();
  //}

  //saveClaim() {

  //  var count = 0;
  //  var arrC = 0;

  //  this.insuranceService.saveClaim(this.claimObject).subscribe(response => {
  //    this.getClaims(this.currentStatusID);
  //    this.setClaimObj(response);
  //  });

  //  //for (var i = 0; i < this.uploadedFiles.length; i++) {
  //  //  var reader = new FileReader();
  //  //  reader.readAsDataURL(this.uploadedFiles[i]);
  //  //  reader.onload = (file: any) => {

  //  //    let data = { ID: 0, ClaimID: 0, FileType: this.uploadedFiles[arrC].type, FileName: this.uploadedFiles[arrC].name, FileURL: "", FileData: file.target.result.split(',')[1] };

  //  //    if (this.claimObject.Attachments.indexOf(data) === -1)
  //  //      this.claimObject.Attachments.push(data);

  //  //    count += 1;
  //  //    arrC += 1

  //  //    if (count == this.uploadedFiles.length) {

  //  //      this.insuranceService.saveClaim(this.claimObject).subscribe(response => {
  //  //        this.getClaims(this.currentStatusID);
  //  //        this.setClaimObj(response);
  //  //      });
  //  //    }
  //  //  }

  //  //}
  //  //if (this.uploadedFiles.length == 0) {
  //  //  this.insuranceService.saveClaim(this.claimObject).subscribe(response => {
  //  //    this.getClaims(this.currentStatusID);
  //  //    this.setClaimObj(response);
  //  //  });
  //  //}
  //}

  //setClaimObj(response) {
  //  this.bikes = [];
  //  this.bikeSelectList = [];
  //  this.allNotes = [];
  //  this.components = [];

  //  if (response !== "") {
  //    var obj = JSON.parse(response);
  //    for (var i = 0; i < obj.Claims.length; i++) {
  //      this.claimObject = obj.Claims[i];
  //    }

  //    for (var i = 0; i < this.claimObject.Bikes.length; i++) {
  //      this.bikes.push(this.claimObject.Bikes[i].Name);
  //      this.bikeSelectList.push({ label: this.claimObject.Bikes[i].Name, value: this.claimObject.Bikes[i].Name });
  //    }

  //    for (var i = 0; i < this.claimObject.Notes.length; i++) {
  //      this.allNotes.push(this.claimObject.Notes[i]);
  //    }

  //    for (var i = 0; i < this.allNotes.length; i++) {
  //      if (this.allNotes[i].Completed === false)
  //        this.allNotes[i].DueDate = new Date(this.allNotes[i].DueDate);
  //    }

  //    this.statuses = [];
  //    for (var i = 0; i < this.navigationItems.length; i++) {
  //      if (this.navigationItems[i].title == this.claimObject.Status) {
  //        this.statuses.push({ label: this.navigationItems[i].title, value: { ID: this.navigationItems[i].ID, title: this.navigationItems[i].title, backgroundImage: this.navigationItems[i].backgroundImage } });
  //      }
  //    }
  //    for (var i = 0; i < this.navigationItems.length; i++) {
  //      if (this.navigationItems[i].title !== this.claimObject.Status) {
  //        this.statuses.push({ label: this.navigationItems[i].title, value: { ID: this.navigationItems[i].ID, title: this.navigationItems[i].title, backgroundImage: this.navigationItems[i].backgroundImage } });
  //      }
  //    }

  //    for (var i = 0; i < this.incidentTypes.length; i++) {
  //      if (this.incidentTypes[i].label == this.claimObject.IncidentType) {

  //        this.incidentTypes = [
  //          { label: this.incidentTypes[i].label, value: { label: this.incidentTypes[i].label } },
  //          { label: 'Select New Incident Type', value: null },
  //          { label: 'Accidental damage', value: { label: "Accidental damage" } },
  //          { label: 'Theft from home', value: { label: "Theft from home" } },
  //          { label: 'Theft away from home', value: { label: "Theft away from home" } },
  //        ];

  //        this.selectedIncidentType = this.incidentTypes[0];

  //      }
  //    }

  //    if (this.bikeSelectList.length > 0) {
  //      this.bikeSelected = this.bikeSelectList[0].value;
  //      this.showComponents();
  //    }
  //    this.claimObject.IncidentDate = new Date(this.claimObject.IncidentDate);
  //  }
  //}

  //showPage(id) {
  //  this.dontMinimizeAndSaveClaim();

  //  this.showTasks = false;
  //  this.showClaims = false;
  //  this.showAttachments = false;
  //  this.showQuotes = false;
  //  this.showMessages = false;
  //  this.showProcurement = false;

  //  if (id === 1)
  //    this.showTasks = true;
  //  if (id === 2)
  //    this.showClaims = true;
  //  if (id === 3) {

  //    //for (var i = 0; i < this.claimObject.Attachments.length; i++) {
  //    //  if (this.claimObject.Attachments[i].FileType !== undefined)
  //    //    if (this.claimObject.Attachments[i].FileType.startsWith("image")) {
  //    //      //this.claimObject.Attachments[i].OverLay = [];
  //    //      //this.claimObject.Attachments[i].OverLay.push(new google.maps.Marker({ position: { lat: this.claimObject.Attachments[i].Lat, lng: this.claimObject.Attachments[i].Long }, title: "Image location" }))
  //    //      this.images.push(this.claimObject.Attachments[i]);// = this.statuses[i];
  //    //    }
  //    //      //this.images.push({ source: this.claimObject.Attachments[i].FileURL, alt: "", title: this.claimObject.Attachments[i].FileName });// = this.statuses[i];
  //    //}

  //    //for (var i = 0; i < this.claimObject.Attachments.length; i++) {
  //    //  if (this.claimObject.Attachments[i].FileType !== undefined)
  //    //    if (!this.claimObject.Attachments[i].FileType.startsWith("image"))
  //    //      this.documents.push({ source: this.claimObject.Attachments[i].FileURL, title: this.claimObject.Attachments[i].FileName });// = this.statuses[i];
  //    //}

  //    this.showAttachments = true;
  //  }
  //  if (id === 4)
  //    this.showQuotes = true;
  //  if (id === 5)
  //    this.showMessages = true;
  //  if (id === 6)
  //    this.showProcurement = true;
  //}

  ////createTask() {
  ////  if (this.note.length > 0) {
  ////    var date = new Date();
  ////    this.allNotes.push(
  ////      {
  ////        ID: 0,
  ////        ClaimID: this.claimObject.ID,
  ////        DueDate: date,
  ////        Description: this.note,
  ////        Completed: false,
  ////        Assignee: this.helpersService.getProfileData().Name + ' ' + this.helpersService.getProfileData().Surname,
  ////        AssigneeID: this.claimObject.AssigneeID,
  ////      }
  ////    );

  ////    this.note = "";
  ////  }
  ////}

  ////createNote() {
  ////  if (this.note.length > 0) {
  ////    var date = new Date();
  ////    this.allNotes.push(
  ////      {
  ////        ID: 0,
  ////        ClaimID: this.claimObject.ID,
  ////        DueDate: date,
  ////        Description: this.note,
  ////        Completed: true,
  ////        Assignee: this.helpersService.getProfileData().Name + ' ' + this.helpersService.getProfileData().Surname,
  ////        AssigneeID: this.claimObject.AssigneeID,
  ////      }
  ////    );

  ////    this.note = "";
  ////  }
  ////}

  ////completeTask(position) {
  ////  for (var i = 0; i < this.allNotes.length; i++) {
  ////    if (i == position) {
  ////      this.allNotes[i].Completed = true;
  ////      this.allNotes[i].DueDate = this.allNotes[i].DueDate.toJSON();
  ////    }
  ////  }

  ////  for (var i = 0; i < this.allNotes.length; i++) {
  ////    for (var x = 0; x < this.claimObject.Notes.length; x++) {
  ////      if (this.allNotes[i].Desription !== undefined) {
  ////        if (this.allNotes[i].Description == this.claimObject[x].Description) {
  ////          this.claimObject[x].Completed = true;
  ////        }
  ////      }
  ////    }
  ////  }
  ////}

  //addBike(event) {
  //  this.bikeSelectList.push({ label: event.value, value: event.value });
  //  this.claimObject.Bikes.push({ ID: 0, Name: event.value, Components: [], Excess: 0, SumInsured: 0 });
  //}

  //addComponentToBike(event) {
  //  for (var i = 0; i < this.claimObject.Bikes.length; i++) {
  //    if (this.claimObject.Bikes[i].Name === this.bikeSelected.toString()) {
  //      if (this.claimObject.Bikes[i].Components == undefined)
  //        this.claimObject.Bikes[i].Components = [];

  //      this.claimObject.Bikes[i].Components.push({ ID: 0, Description: event.value });
  //    }
  //  }

  //}

  //removeBike(event) {

  //  for (var i = 0; i < this.bikeSelectList.length; i++) {
  //    if (this.bikeSelectList[i].label === event.value) {
  //      this.bikeSelectList.splice(i, 1);
  //      i--;
  //    }
  //  }

  //  for (var i = 0; i < this.claimObject.Bikes.length; i++) {
  //    if (this.claimObject.Bikes[i].Name === event.value) {
  //      this.claimObject.Bikes.splice(i, 1);
  //      i--;
  //    }
  //  }
  //}

  //removeComponentToBike(event) {
  //  for (var i = 0; i < this.claimObject.Bikes.length; i++) {
  //    if (this.claimObject.Bikes[i].Name === this.bikeSelected.toString()) {
  //      for (var x = 0; x < this.claimObject.Bikes[i].Components.length; x++) {
  //        if (this.claimObject.Bikes[i].Components[x] === event.value) {
  //          this.claimObject.Bikes[i].Components.splice(x, 1);
  //          x--;
  //        }
  //      }
  //    }
  //  }
  //}

  //addExcessToBike() {
  //  for (var i = 0; i < this.claimObject.Bikes.length; i++) {
  //    if (this.claimObject.Bikes[i].Name === this.bikeSelected.toString()) {
  //      this.claimObject.Bikes[i].Excess = (this.excess);
  //    }
  //  }
  //}

  //addSumInsuredToBike() {
  //  for (var i = 0; i < this.claimObject.Bikes.length; i++) {
  //    if (this.claimObject.Bikes[i].Name === this.bikeSelected.toString()) {
  //      this.claimObject.Bikes[i].SumInsured = (this.sumInsured);
  //    }
  //  }
  //}

  //showComponents() {
  //  this.components = [];
  //  for (var i = 0; i < this.claimObject.Bikes.length; i++) {
  //    if (this.claimObject.Bikes[i].Name === this.bikeSelected.toString()) {
  //      if (this.claimObject.Bikes[i].Components !== undefined) {
  //        for (var x = 0; x < this.claimObject.Bikes[i].Components.length; x++) {
  //          this.components.push(this.claimObject.Bikes[i].Components[x].Description);
  //        }
  //      }
  //      //const formatter = new Intl.NumberFormat('en', { style: 'currency', currency: 'ZAR'});
  //      //formatter.format(987654.321);

  //      this.excess = this.claimObject.Bikes[i].Excess;
  //      this.sumInsured = this.claimObject.Bikes[i].SumInsured;
  //    }
  //  }
  //}

  //setStatus() {
  //  this.claimObject.StatusID = this.selectedStatus.ID;
  //  this.claimObject.Status = this.selectedStatus.title;
  //  this.dontMinimizeAndSaveClaim();
  //}

  //setEmployee() {
  //  this.claimObject.AssigneeID = this.selectedEmployee.ID;
  //  this.claimObject.AssigneeName = this.selectedEmployee.Name;
  //  this.dontMinimizeAndSaveClaim();
  //}

  //formatMoney(number, decPlaces, decSep, thouSep) {
  //  decPlaces = isNaN(decPlaces = Math.abs(decPlaces)) ? 2 : decPlaces,
  //    decSep = typeof decSep === "undefined" ? "." : decSep;
  //  thouSep = typeof thouSep === "undefined" ? "," : thouSep;
  //  var sign = number < 0 ? "-" : "";
  //  var i = String(parseInt(number = Math.abs(Number(number) || 0).toFixed(decPlaces)));
  //  var j = (j = i.length) > 3 ? j % 3 : 0;

  //  var obj = sign +
  //    (j ? i.substr(0, j) + thouSep : "") +
  //    i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
  //    (decPlaces ? decSep + Math.abs(number - parseInt(i)).toFixed(decPlaces).slice(2) : "");

  //  return obj;
  //}

  //setTaskEmployee(id, event) {
  //  this.allNotes[id].AssigneeID = event.value.ID;
  //  this.allNotes[id].AssigneeName = event.value.Name;
  //}

  //setTaskDueDate(id, event) {
  //  this.dueDate = null;
  //}

  //onUpload(event) {
  //  var cont = true;
  //  for (let file of event.files) {
  //    if (this.uploadedFiles.indexOf(file) === -1)
  //      this.uploadedFiles.push(file);
  //  }
  //}

  //onRemove(event) {
  //  this.uploadedFiles.splice(this.uploadedFiles.indexOf(event.file), 1);
  //}
}
